module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('el-row', {
    staticStyle: {
      "padding": "10px 0px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "refCode",
      "label": _vm.$t('customer.refCode'),
      "rules": [{
        required: true,
        message: 'Please input reference code',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.refCode),
      callback: function($$v) {
        _vm.form.refCode = $$v
      },
      expression: "form.refCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "customerGroup",
      "label": _vm.$t('customer.type'),
      "rules": [{
        required: true,
        message: 'Please select customer category',
        trigger: 'blur'
      }]
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('customer.category')
    },
    model: {
      value: (_vm.form.customerGroup),
      callback: function($$v) {
        _vm.form.customerGroup = $$v
      },
      expression: "form.customerGroup"
    }
  }, _vm._l((_vm.groups), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('customer.name'),
      "rules": [{
        required: true,
        message: 'Please input customer\'s name',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.form.name = $$v
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "phoneNumber",
      "label": _vm.$t('customer.phoneNumber'),
      "rules": [{
        type: 'string',
        min: 9,
        max: 10,
        message: 'Please input a valid phone number',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.phoneNumber),
      callback: function($$v) {
        _vm.form.phoneNumber = $$v
      },
      expression: "form.phoneNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('customer.birthday')
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('base.pickdate')
    },
    model: {
      value: (_vm.form.birthday),
      callback: function($$v) {
        _vm.form.birthday = $$v
      },
      expression: "form.birthday"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('customer.lineId')
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.lineId),
      callback: function($$v) {
        _vm.form.lineId = $$v
      },
      expression: "form.lineId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": _vm.$t('customer.email'),
      "rules": [{
        type: 'email',
        message: 'Please enter a valid email',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addTab(_vm.selectedAddress)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('customer.addAddress')) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card",
      "closable": ""
    },
    on: {
      "tab-remove": _vm.removeTab
    },
    model: {
      value: (_vm.selectedAddress),
      callback: function($$v) {
        _vm.selectedAddress = $$v
      },
      expression: "selectedAddress"
    }
  }, _vm._l((_vm.form.addresses), function(item, index) {
    return _c('el-tab-pane', {
      key: item.name,
      attrs: {
        "label": item.title,
        "name": item.name
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('customer.addressName')
      }
    }, [_c('el-input', {
      model: {
        value: (_vm.form.addresses[index].title),
        callback: function($$v) {
          _vm.form.addresses[index].title = $$v
        },
        expression: "form.addresses[index].title"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('customer.address')
      }
    }, [_c('el-input', {
      model: {
        value: (_vm.form.addresses[index].address),
        callback: function($$v) {
          _vm.form.addresses[index].address = $$v
        },
        expression: "form.addresses[index].address"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('customer.district')
      }
    }, [_c('el-input', {
      model: {
        value: (_vm.form.addresses[index].district),
        callback: function($$v) {
          _vm.form.addresses[index].district = $$v
        },
        expression: "form.addresses[index].district"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('customer.subDistrict')
      }
    }, [_c('el-input', {
      model: {
        value: (_vm.form.addresses[index].subDistrict),
        callback: function($$v) {
          _vm.form.addresses[index].subDistrict = $$v
        },
        expression: "form.addresses[index].subDistrict"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('customer.province')
      }
    }, [_c('el-input', {
      model: {
        value: (_vm.form.addresses[index].province),
        callback: function($$v) {
          _vm.form.addresses[index].province = $$v
        },
        expression: "form.addresses[index].province"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('customer.country')
      }
    }, [_c('el-input', {
      model: {
        value: (_vm.form.addresses[index].country),
        callback: function($$v) {
          _vm.form.addresses[index].country = $$v
        },
        expression: "form.addresses[index].country"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('customer.zipCode')
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number"
      },
      model: {
        value: (_vm.form.addresses[index].zipCode),
        callback: function($$v) {
          _vm.form.addresses[index].zipCode = $$v
        },
        expression: "form.addresses[index].zipCode"
      }
    })], 1)], 1)], 1)], 1)
  }))], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', {
    staticClass: "form-header"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('customer.image')) + "\n            ")]), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": _vm.imageActionURL,
      "headers": _vm.imageHeaders,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "file-list": _vm.fileList,
      "on-success": _vm.handleImageUploaded,
      "on-remove": _vm.handleRemove
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.imgDialog),
      callback: function($$v) {
        _vm.imgDialog = $$v
      },
      expression: "imgDialog"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImgUrl,
      "alt": ""
    }
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit(_vm.form)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.save')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'customer.view'
      }
    }
  }, [_c('el-button', [_vm._v(_vm._s(_vm.$t('base.cancel')))])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81ca47c8"}!./src/pages/customer/edit/index.html
// module id = 815
// module chunks = 1